import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoTreeListDataSourceMixin from './KendoTreeListDataSourceMixin'

export default {
    name: 'kendo-treelistdatasource',
    mixins: [ KendoTreeListDataSourceMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoTreeListDataSource/index.js